import React from 'react'
import { Box } from '@mui/material'

function LogInNav() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        height: '5vh',
        width: '95vw',
        borderBottom: '1px solid #FFFFFF'
      }}
    ></Box>
  )
}

export default LogInNav
